// extracted by mini-css-extract-plugin
export default {"Care":"CareMPage_Care__BDwwL","depth2":"CareMPage_depth2__deGu2","subtitle":"CareMPage_subtitle__GuIsE","image":"CareMPage_image__wFtFP","service":"CareMPage_service__yeQMN"};